import { memo } from 'react';
import { useFetchCampaignsAssociationSettings, hasCampaignsReadAccess } from './hooks/useFetchCampaignsAssociationSettings';
import CampaignFilter from '../components/campaignSelect/CampaignFilter';
import { jsx as _jsx } from "react/jsx-runtime";
function CampaignsPlatformFilter({
  objectType,
  value,
  onChange,
  multi = false,
  showLabel = true,
  labelStyle = {
    inlineSize: '100%'
  }
}) {
  const {
    data: associationSettings,
    loading: associationSettingsLoading
  } = useFetchCampaignsAssociationSettings();
  if (associationSettingsLoading || !associationSettings || !associationSettings[objectType]) {
    return null;
  }
  return /*#__PURE__*/_jsx(CampaignFilter, {
    value: value,
    onChange: onChange,
    hasCampaignsReadAccess: hasCampaignsReadAccess(associationSettings, objectType),
    showLabel: showLabel,
    multi: multi,
    labelStyle: labelStyle
  });
}
export default /*#__PURE__*/memo(CampaignsPlatformFilter);